<template>
    <div class="background-notificador" v-if="$temAcessoView('BORDEROS-05') && notificacoes > 0 && mostrarNotificacao">
        <div class="icon-container mt-1">
            <div class="exclamation-icon">!</div>
        </div>
        <div>
            <span class="titulo mb-5">Autorizador Financeiro</span>
            <br />
            <span class="texto-notificacao">{{ notificacoes }} autorizações aguardando você</span>
        </div>
        <div class="botao">
            <Button
                label="Ir para autorizador"
                @click="listarBorderos()"
                class="responsive-button"
                style="background-color: white; color: #2f3f53; font-family: 'Lato', sans-serif"
            />
        </div>
    </div>
</template>
<script>
import notificacaoService from './services';

export default {
    data() {
        return {
            notificacoes: null,
        };
    },

    mounted() {
        this.obterBoderos();
    },

    methods: {
        listarBorderos() {
            this.$router.push({ name: 'Listagem_Borderos_Aguardando' });
        },

        obterBoderos() {
            if (!this.$temAcessoView('BORDEROS-00')) return;

            this.$store.dispatch('addRequest');
            notificacaoService.obterQuantidade().then((response) => {
                if (response?.success) {
                    this.notificacoes = response.data;
                } else {
                    this.erros = response.errors;
                }
                this.$store.dispatch('removeRequest');
            });
        },
    },

    computed: {
        mostrarNotificacao() {
            return this.$route.name == 'DashBoard';
        },
    },

    watch: {
        $route() {
            if (this.$route.name == 'DashBoard' || this.$route.name == 'home') this.obterBoderos();
        },
    },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap');

.background-notificador {
    width: calc(100% + 32px);
    margin-left: -16px;
    margin-top: -16px;
    font-family: 'Lato', sans-serif;
    font-weight: 600;
    background-color: #c2f3ff;
    display: flex;
    align-items: center;
    padding: 20px 16px !important;
}

.icon-container {
    display: flex;
    align-self: flex-start;
    align-items: center;
    justify-content: center;
    width: 1.8rem;
    height: 1.8rem;
    background-color: #113555;
    border-radius: 16px;
    flex-shrink: 0;
}

.exclamation-icon {
    color: white;
    font-size: 1rem;
    font-weight: bold;
    border-radius: 50%;
    width: 1.8rem;
    height: 1.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.titulo {
    margin-left: 0.5rem;
    font-size: 14px;
    font-weight: 600;
    color: #2f3f53;
    line-height: 19.6px;
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
}
.texto-notificacao {
    font-family: 'Lato', sans-serif;
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 19.2px;
    margin-left: 0.5rem;
    text-align: left;
    color: #2f3f53;
    display: inline-block;
    word-wrap: break-word;
    width: 100%;
}

.botao {
    margin-right: 0;
    margin-left: auto;
}

.responsive-button {
    width: 121px;
    max-width: 200px;
    height: 32px;
    white-space: nowrap;
    flex-shrink: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    border-radius: 4px;
    padding: 10px 7px;
    border: 1px solid #979fa9 !important;
}

@media (max-width: 360px) {
    .background-notificador {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-top: -16px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        background-color: #c2f3ff;
        display: flex;
        align-items: center;
        padding: 20px 16px !important;
    }
    .titulo {
        font-size: 12px;
    }
    .responsive-button {
        max-width: 120px;
    }
    .texto-notificacao {
        font-size: 11px;
        white-space: normal;
        word-wrap: break-word;
    }
}

@media (min-width: 361px) and (max-width: 768px) {
    .background-notificador {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-top: -16px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        background-color: #c2f3ff;
        display: flex;
        align-items: center;
        padding: 20px 16px !important;
    }
    .titulo {
        font-size: 14px;
    }
    .responsive-button {
        max-width: 140px;
    }
    .texto-notificacao {
        font-size: 13px;
    }
}

@media (min-width: 769px) and (max-width: 1024px) {
    .background-notificador {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-top: -16px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        background-color: #c2f3ff;
        display: flex;
        align-items: center;
        padding: 20px 16px !important;
    }
    .titulo {
        font-size: 16px;
    }
    .responsive-button {
        max-width: 160px;
    }
    .texto-notificacao {
        font-size: 15px;
    }
}

@media (min-width: 1025px) and (max-width: 1440px) {
    .background-notificador {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-top: -16px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        background-color: #c2f3ff;
        display: flex;
        align-items: center;
        padding: 20px 16px !important;
    }
    .titulo {
        font-size: 18px;
    }
    .responsive-button {
        max-width: 280px;
    }
    .texto-notificacao {
        font-size: 17px;
    }
}

@media (min-width: 1441px) and (max-width: 1920px) {
    .background-notificador {
        width: calc(100% + 32px);
        margin-left: -16px;
        margin-top: -16px;
        font-family: 'Lato', sans-serif;
        font-weight: 600;
        background-color: #c2f3ff;
        display: flex;
        align-items: center;
        padding: 20px 16px !important;
    }
    .titulo {
        font-size: 20px;
    }
    .responsive-button {
        max-width: 200px;
        width: auto;
        font-size: 0.9em;
        padding: 12px 22px;
    }
    .texto-notificacao {
        font-size: 19px;
    }
}
</style>
